import { Drawer, FormControl, Grid, Icon, InputLabel, MenuItem, Select, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { FormStatusEnum } from "../../_common/enum/forms/formStatus.enum";
import { IFormTemplateManage } from "../../_common/models/formTemplate";
import { PrimaryButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { formTemplateService } from "../../_services/formTemplate.service";
import { useDrawerStyles } from "../../_styles/drawer.styles";
import { eventDocumentTemplateService } from "../../_services/eventDocumentTemplate.service";

export function EventDocumentTemplateManageDrawer(params: {
    emitOnSave: (id?: number) => void,
    emitOnClose: () => void
}) {
    const { eventDocumentTemplateId } = useParams<{ eventDocumentTemplateId: string }>();

    const [data, setData] = useState<IFormTemplateManage>(getResetData);
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setSaving] = useState(false);
    const [tabValue, setTabValue] = React.useState(0);

    let navigate = useNavigate();

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        if (eventDocumentTemplateId) fetchData();
        else setData(getResetData);
    }, [eventDocumentTemplateId]);

    function getResetData(): IFormTemplateManage {
        return {
            id: 0 || +(eventDocumentTemplateId || 0),
            name: "",
            formTemplateTypeId: 0
        };
    }

    function fetchData() {
        setLoading(true);
        return eventDocumentTemplateService
            .get(+(eventDocumentTemplateId || 0))
            .then(
                (json) => {
                    if (json) {
                        setData(json);
                    }
                    else setData(getResetData);
                }
            )
            .finally(() => setLoading(false));
    }

    function closeModal() {
        params.emitOnClose();
    }

    function save(e: any) {
        e.preventDefault();
        setSaving(true);

        return eventDocumentTemplateService
            .submit(data)
            .then(
                (id: number) => {
                    toastr.success("Saved successfully");
                    params.emitOnSave(id);
                }
            )
            .finally(() => setSaving(false));
    }

    function disable() {
        setSaving(true);
        return eventDocumentTemplateService
            .disable(+(eventDocumentTemplateId || 0))
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    params.emitOnClose();
                }
            )
            .finally(() => setSaving(false));
    }

    function handleChange(event: any) {
        setData((_data) => ({ ..._data, [event.target.name]: event.target.value }))
    };

    function onError(event: any) {
        toastr.error("Please verify that all fields have correct input");
    }

    return (
        <Drawer
            anchor={"right"}
            open={true}>

            <ValidatorForm onError={onError} onSubmit={save} noValidate>

                <DrawerHeader name={(!!eventDocumentTemplateId) ? "Update Document Template" : "Create Document Template"} onClose={closeModal} />

                {(+(eventDocumentTemplateId || 0) > 0) &&
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="simple tabs example">
                        <Tab label="Template" onClick={() => { navigate("") }} />
                        <Tab label="Documents" onClick={() => { navigate("EventDocuments") }} />
                    </Tabs>
                }

                {(tabValue === 0) &&
                    <>
                        <Grid container spacing={1} sx={useDrawerStyles.container}>
                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    label="Name"
                                    value={data.name}
                                    name="name"
                                    required
                                    fullWidth
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={data.id == 0 ? 12 : 6}>
                                <PrimaryButton
                                    type="submit"
                                    variant="save">
                                    Save
                                </PrimaryButton>
                            </Grid>

                            {(data.id > 0) &&
                                <Grid item xs={6}>
                                    <PrimaryButton
                                        type="button"
                                        variant="remove"
                                        disabled={isLoading || isSaving}
                                        onClick={disable}>
                                        Disable
                                    </PrimaryButton>
                                </Grid>
                            }

                        </Grid>
                    </>
                }

            </ValidatorForm>

            {(tabValue === 1) &&
                <Outlet />
            }

        </Drawer >
    );
}